import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Facebook, Linkedin } from 'lucide-react';

/* Custom social glyphs for icons lucide doesn't ship. */
const XFooterIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const MediumIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zM20.96 12c0 3.54-1.51 6.42-3.39 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.39 2.87 3.39 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.82 24 12z" />
  </svg>
);

const ThreadsIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.18 24h-.07C8.32 23.97 5.41 22.79 3.5 20.49c-1.7-2.04-2.58-4.88-2.61-8.43v-.13c.03-3.55.91-6.39 2.61-8.43C5.41 1.21 8.32.03 12.11 0h.07c2.91.02 5.34.7 7.21 2.04 1.76 1.26 3 3.05 3.69 5.31l-2.21.66c-1.17-3.83-3.86-5.78-8.7-5.81-3.18.02-5.59.97-7.16 2.83-1.47 1.74-2.23 4.26-2.26 7.47.03 3.21.79 5.73 2.26 7.47 1.57 1.86 3.98 2.81 7.16 2.83 2.86-.02 4.76-.7 6.34-2.27 1.79-1.79 1.76-3.98 1.18-5.31-.34-.78-.96-1.43-1.79-1.91-.21 1.49-.68 2.7-1.42 3.61-.99 1.21-2.4 1.87-4.18 1.96-1.36.07-2.66-.25-3.68-.91-1.19-.78-1.89-1.97-1.96-3.36-.07-1.36.47-2.62 1.51-3.55 1-.89 2.39-1.41 4.04-1.5.91-.05 1.76 0 2.55.13-.1-.65-.31-1.16-.62-1.53-.42-.51-1.07-.77-1.94-.78-.74 0-1.74.21-2.38 1.16l-1.95-1.31c.85-1.27 2.24-1.96 4.34-1.96 1.7 0 3.04.55 3.99 1.65.83.96 1.27 2.27 1.31 3.91.62.27 1.16.59 1.6.95 1.43 1.16 2.21 2.85 2.21 4.81 0 1.74-.7 3.4-2.05 4.79-1.58 1.62-3.74 2.43-6.56 2.43z"/>
  </svg>
);

const BlueskyIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z"/>
  </svg>
);

const SnapchatIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.166.014c.45-.01.957.001 1.366.029 1.144.077 2.28.395 3.297 1.029a6.81 6.81 0 0 1 2.117 2.052c.595.881.96 1.857 1.139 2.86.094.529.17 1.064.171 1.602.003.747-.04 1.494-.11 2.238-.022.236.02.345.272.412.304.082.621.135.917.241.354.128.695.305.901.642.231.379.117.769-.224 1.054-.41.343-.913.51-1.412.66-.62.187-1.249.343-1.853.587-.317.128-.412.34-.323.668.244.892.78 1.61 1.418 2.249.787.787 1.701 1.39 2.764 1.728.4.127.83.169 1.247.249.238.045.486.118.516.41.03.293-.187.443-.42.55-.884.408-1.835.555-2.787.7-.305.046-.426.171-.514.45-.097.31-.184.626-.319.92-.122.265-.343.402-.642.371-.323-.034-.643-.097-.964-.155-.823-.148-1.642-.215-2.474-.05-.504.1-.918.387-1.317.685-.79.589-1.612 1.107-2.582 1.346-.504.124-1.018.171-1.534.103-1.116-.149-2.044-.694-2.886-1.398-.477-.398-.95-.736-1.566-.85-.806-.15-1.604-.06-2.398.092-.291.056-.581.117-.876.146-.298.029-.502-.119-.62-.385-.13-.291-.214-.6-.31-.904-.085-.27-.197-.405-.508-.45-.952-.143-1.901-.291-2.781-.7-.232-.108-.45-.255-.42-.55.029-.291.275-.366.515-.41.418-.078.847-.121 1.247-.249 1.063-.337 1.977-.94 2.764-1.728.638-.638 1.176-1.357 1.42-2.249.088-.328-.007-.541-.324-.668-.604-.244-1.232-.4-1.854-.587-.498-.15-1.001-.317-1.412-.66-.34-.285-.454-.675-.224-1.054.207-.337.547-.514.901-.642.296-.106.613-.16.917-.241.252-.067.295-.176.272-.412-.071-.744-.114-1.491-.111-2.238 0-.538.077-1.073.171-1.601.18-1.004.544-1.98 1.14-2.861a6.81 6.81 0 0 1 2.117-2.052C9.553.443 10.69.124 11.834.048c.243-.017.485-.027.728-.034h-.396z"/>
  </svg>
);

const SOCIAL_LINKS = [
  { url: 'https://www.instagram.com/levanta.life/', label: 'Instagram', Icon: Instagram },
  { url: 'https://www.facebook.com/LevantaLife/', label: 'Facebook', Icon: Facebook },
  { url: 'https://www.tiktok.com/@levanta.life', label: 'TikTok', Icon: TikTokIcon },
  { url: 'https://www.youtube.com/@Levanta_life', label: 'YouTube', Icon: Youtube },
  { url: 'https://www.snapchat.com/add/levanta.life', label: 'Snapchat', Icon: SnapchatIcon },
  { url: 'https://www.linkedin.com/company/levanta-life', label: 'LinkedIn', Icon: Linkedin },
  { url: 'https://x.com/Levantaapp', label: 'X', Icon: XFooterIcon },
  { url: 'https://www.threads.com/@levanta.life', label: 'Threads', Icon: ThreadsIcon },
  { url: 'https://medium.com/levanta-life', label: 'Medium', Icon: MediumIcon },
  { url: 'https://bsky.app/profile/levantalife.bsky.social', label: 'Bluesky', Icon: BlueskyIcon },
];

const PRODUCT = [
  { to: '/', label: 'Home' },
  { to: '/how-it-works', label: 'How Levanta Works' },
  { to: '/levanta-story', label: "Levanta's Story" },
];
const COMPANY = [
  { to: '/mission', label: 'Our Mission' },
  { to: '/vision', label: 'Our Vision' },
  { to: '/founder', label: 'About the Founder' },
  // { to: '/team', label: 'Team' },  // temporarily disabled
];
const SUPPORT = [
  { to: '/contact', label: 'Contact' },
  { to: '/faq', label: 'FAQ' },
  // { to: '/affiliates', label: 'Affiliates' },  // unlisted for now — link-only access
];
const CONTENT = [
  { to: '/media-press', label: 'Media & Press' },
  { to: '/blog', label: 'Blog' },
];

/**
 * Shared dark-slate footer. Used on the homepage, FAQ, and any page that
 * adopts the new design language.
 */
const AltFooter = () => {
  return (
    <footer
      className="relative bg-[#0a0f1c] text-white"
      data-testid="alt-footer"
    >
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-x-8 gap-y-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/logo-white.png"
                alt="Levanta"
                className="h-10 w-10 object-contain"
              />
              <img
                src="/wordmark-white.png"
                alt="LEVANTA"
                className="h-5 w-auto"
              />
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-7 max-w-xs">
              The Structured Growth System for Real Life.
            </p>
            <div className="flex flex-wrap gap-3">
              {SOCIAL_LINKS.map(({ url, label, Icon }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="me noopener noreferrer"
                  aria-label={label}
                  title={label}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/15 flex items-center justify-center transition-colors duration-200 ring-1 ring-white/10"
                >
                  <Icon className="w-4 h-4 text-white/80" />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-5">Product</h4>
            <ul className="space-y-4 text-sm text-white/65">
              {PRODUCT.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-5">Company</h4>
            <ul className="space-y-4 text-sm text-white/65">
              {COMPANY.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Download */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-5">Download</h4>
            <ul className="space-y-4 text-sm text-white/65">
              <li>
                <Link to="/download-app" className="hover:text-white transition-colors">
                  Google Play
                </Link>
              </li>
              <li>
                <Link to="/download-app" className="hover:text-white transition-colors">
                  App Store
                </Link>
              </li>
              <li>
                <span className="text-white/35 cursor-not-allowed select-none">
                  Windows
                  <span className="ml-1 text-[10px] uppercase tracking-widest text-white/45">soon</span>
                </span>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-5">Support</h4>
            <ul className="space-y-4 text-sm text-white/65">
              {SUPPORT.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Content */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-white mb-5">Content</h4>
            <ul className="space-y-4 text-sm text-white/65">
              {CONTENT.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom strip — copyright + legal links */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/45">
            © {new Date().getFullYear()} Levanta. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs text-white/55">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AltFooter;
